var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "overflow-hidden white",
    staticStyle: {
      "font-size": "1.8rem"
    }
  }, [_c('p', {
    staticClass: "pv4 tc"
  }, [_c('span', {
    staticClass: "dn dib-ns ph3"
  }, [_vm._v("Staromeštianska pivotéka")]), _vm._v(" "), _c('strong', {
    staticClass: "dib ph3"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.mobileNumber.replace(/ /g, '')
    }
  }, [_vm._v(_vm._s(_vm.mobileNumber))])]), _vm._v(" "), (_vm.openingHours[_vm.today.getDay()]) ? _c('span', {
    staticClass: "dib ph3"
  }, [(_vm.openingHours[_vm.today.getDay()].closed === true) ? _c('span', [_vm._v(_vm._s(this.isEnglish ? 'Closed today' : 'Dnes zatvorené'))]) : _c('span', [_vm._v(_vm._s(this.isEnglish ? 'Open today' : 'Dnes otvorené'))]), _vm._v(" "), (_vm.openingHours[_vm.today.getDay()].closed !== true) ? _c('strong', {
    staticClass: "nowrap"
  }, [_vm._v("\n            " + _vm._s(_vm.openingHours[_vm.today.getDay()].openFrom) + "\n            -\n            " + _vm._s(_vm.openingHours[_vm.today.getDay()].openTo) + "\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.nameToday && _vm.nameToday[0] !== '_') ? _c('span', {
    staticClass: "dib ph3"
  }, [_vm._v("\n          " + _vm._s(this.isEnglish ? 'Name day today' : 'Meniny má') + "\n          "), _c('strong', [_vm._v(_vm._s(_vm.nameToday))]), (_vm.nameTomorrow && _vm.nameTomorrow[0] !== '_') ? _c('span', [_vm._v(", " + _vm._s(this.isEnglish ? 'tomorrow' : 'zajtra') + " " + _vm._s(_vm.nameTomorrow) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pointer pl3",
    on: {
      "click": _vm.updateLanguage
    }
  }, [_vm._v(_vm._s(this.isEnglish ? '🇬🇧 anglický jazyk' : '🇸🇰 slovenský jazyk'))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 bg-white"
  }, [_c('div', {
    staticClass: "ph4 ph5-l pt5 pb4"
  }, [_vm._m(0), _vm._v(" "), (!_vm.isWysiwygEmpty(this.weeklyBeer) || _vm.isWysiwygEmpty(this.weeklyFood)) ? _c('div', {
    staticClass: "dn-l pt6 overflow-hidden"
  }, [(!_vm.isWysiwygEmpty(this.weeklyBeer)) ? _c('div', {
    staticClass: "pb5"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.isEnglish ? 'images/weekly-beer.en.png' : 'images/weekly-beer.png',
      "alt": "Pivo týždňa"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weekly-beer pt4",
    domProps: {
      "innerHTML": _vm._s(_vm.weeklyBeer)
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isWysiwygEmpty(this.weeklyFood)) ? _c('div', {
    staticClass: "pb5"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.isEnglish ? 'images/weekly-food.en.png' : 'images/weekly-food.png',
      "alt": "Špecialita týždňa"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weekly-food pt4",
    domProps: {
      "innerHTML": _vm._s(_vm.weeklyFood)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('smp-beers-on-tap', {
    attrs: {
      "beers": _vm.beersOnTap,
      "isEnglish": this.isEnglish,
      "months": this.months
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt5 dn db-l"
  }, [_c('h3', {
    staticClass: "ttu"
  }, [_vm._v(_vm._s(_vm.isEnglish ? 'Current' : 'Aktuálne'))]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "white pa4 pa5-l"
  }, [(!_vm.isWysiwygEmpty(this.weeklyBeer) || _vm.isWysiwygEmpty(this.weeklyFood)) ? _c('div', {
    staticClass: "dn db-l overflow-hidden"
  }, [_c('div', {
    staticClass: "row gap-20"
  }, [(!_vm.isWysiwygEmpty(this.weeklyBeer)) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.isEnglish ? 'images/weekly-beer.en.png' : 'images/weekly-beer.png',
      "alt": "Pivo týždňa"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weekly-beer pt4",
    domProps: {
      "innerHTML": _vm._s(_vm.preposFixStr(_vm.weeklyBeer))
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isWysiwygEmpty(this.weeklyFood)) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.isEnglish ? 'images/weekly-food.en.png' : 'images/weekly-food.png',
      "alt": "Špecialita týždňa"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weekly-food pt4",
    domProps: {
      "innerHTML": _vm._s(_vm.preposFixStr(_vm.weeklyFood))
    }
  })]) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "display": "block",
      "margin": "40px 0",
      "height": "17px",
      "background": "url(images/chalkline.png) no-repeat"
    }
  })]) : _vm._e(), _vm._v(" "), _c('smp-menu-offer', {
    attrs: {
      "isEnglish": this.isEnglish
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt4"
  }, [_c('div', {
    staticClass: "col-md-8 mt4 mt0-l"
  }, [_c('div', {
    staticClass: "ba bw3 pa3"
  }, [_c('div', {
    staticClass: "b f2 tc"
  }, [_vm._v(_vm._s(_vm.isEnglish ? 'Allergens' : 'Alergény'))]), _vm._v(" "), _c('div', {
    staticClass: "mb3 tc"
  }, [_vm._v("[výnos č. 2319/2007-100]")]), _vm._v(" "), _c('div', {
    staticClass: "dt f4"
  }, _vm._l((_vm.allergens), function(allergen, i) {
    return _c('div', {
      staticClass: "dt-row"
    }, [_c('div', {
      staticClass: "dtc b"
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('div', {
      staticClass: "dtc pl2"
    }, [_vm._v(_vm._s(_vm._f("preposFix")(allergen)))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt4 mt0-l"
  }, [_c('div', {
    staticClass: "ba bw3 pa3 b lh-copy"
  }, [_c('p', [_vm._v(_vm._s(_vm.isEnglish ? 'The weight of meat and other materials is given in raw state.' : 'Hmotnosť mäsa a ostatných surovín je uvedená v surovom stave.'))]), _vm._v(" "), _c('p', {
    staticClass: "mt4"
  }, [_vm._v(_vm._s(_vm.isEnglish ? 'Our kitchen accepts orders till 9:15 p.m.' : 'Kuchyňa prijíma poslednú objednávku do 21:15.'))]), _vm._v(" "), _c('p', {
    staticClass: "mt4"
  }, [_vm._v(_vm._s(_vm.isEnglish ? 'This menu is arranged by team of our cooks.' : 'Jedálny lístok zostavil tím kuchárov Staromeštianska pivotéka.'))])])])])], 1)])])]), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "container white"
  }, [_c('div', {
    staticClass: "row tc"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {}, [_c('h5', [_vm._v(_vm._s(this.isEnglish ? 'ADDRESS' : 'ADRESA'))]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "mt5"
  }, [_c('h5', [_vm._v(_vm._s(this.isEnglish ? 'RESERVATIONS' : 'REZERVÁCIE'))]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "nowrap",
    staticStyle: {
      "font-size": "1.3em"
    },
    attrs: {
      "href": 'tel:' + _vm.mobileNumber.replace(/ /g, '')
    }
  }, [_vm._v(_vm._s(_vm.mobileNumber))]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:pivoteka@staromestan.beer"
    }
  }, [_vm._v("pivoteka@staromestan.beer")])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {}, [_c('h5', [_vm._v(_vm._s(this.isEnglish ? 'OPENING HOURS' : 'OTVÁRACIE HODINY'))]), _vm._v(" "), _c('p', _vm._l(([1, 2, 3, 4, 5, 6, 0]), function(index) {
    return _c('span', {
      class: {
        'smp-green b': _vm.today.getDay() === index
      }
    }, [_c('span', {
      staticClass: "ttc"
    }, [_vm._v(_vm._s(_vm.weekDays[index]) + ":")]), _vm._v(" "), (_vm.openingHours[index].closed !== true) ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.openingHours[index].openFrom) + " - " + _vm._s(_vm.openingHours[index].openTo) + "\n                ")]) : _c('span', [_vm._v("\n                  " + _vm._s(_vm.isEnglish ? 'closed' : 'zatvorené') + "\n                ")]), _vm._v(" "), _c('br')])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "mt6"
  }, [_c('smp-map')], 1), _vm._v(" "), _c('div', {
    staticClass: "dn-l pt5 tc"
  }, [_c('h3', {
    staticClass: "ttu"
  }, [_vm._v(_vm._s(_vm.isEnglish ? 'Current' : 'Aktuálne'))]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.windowScrollTop > 400),
      expression: "windowScrollTop > 400"
    }],
    staticClass: "scrollup"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollToTop($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-chevron-up"
  })])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center",
    attrs: {
      "src": "images/logo-header.png",
      "alt": "Staromeštianska pivotéka"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fb-page",
    attrs: {
      "data-href": "https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/",
      "data-tabs": "timeline",
      "data-width": "500",
      "data-height": "700",
      "data-small-header": "true",
      "data-adapt-container-width": "true",
      "data-hide-cover": "false",
      "data-show-facepile": "false"
    }
  }, [_c('blockquote', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "cite": "https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/"
    }
  }, [_vm._v("\n                  Staromeštianska pivotéka\n                ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n              Staromeštianska pivotéka "), _c('br'), _vm._v("\n              Kozia 12 "), _c('br'), _vm._v("\n              Bratislava\n              ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "pa5"
  }, [_c('img', {
    staticClass: "img-responsive center",
    attrs: {
      "src": "/images/logo-footer.png",
      "alt": "Staromeštianska pivotéka"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fb-page",
    attrs: {
      "data-href": "https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/",
      "data-tabs": "timeline",
      "data-width": "500",
      "data-height": "700",
      "data-small-header": "true",
      "data-adapt-container-width": "true",
      "data-hide-cover": "false",
      "data-show-facepile": "false"
    }
  }, [_c('blockquote', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "cite": "https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/"
    }
  }, [_vm._v("\n              Staromeštianska pivotéka\n            ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "db dib-ns"
  }, [_c('ul', {
    staticClass: "footer-social"
  }, [_c('li', [_c('a', {
    staticClass: "social-facebook",
    attrs: {
      "href": "https://www.facebook.com/Starome%C5%A1tianska-pivot%C3%A9ka-820451771313386/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon-facebook white"
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "db dib-ns pl4 pt2"
  }, [_vm._v("Staromeštianska pivotéka")]), _vm._v(" "), _c('span', {
    staticClass: "db dib-ns pl4 pt2"
  }, [_c('a', {
    attrs: {
      "href": "mailto:pivoteka@staromestan.beer"
    }
  }, [_vm._v("pivoteka@staromestan.beer")])]), _vm._v(" "), _c('span', {
    staticClass: "db dib-ns pl4 pt2"
  }, [_vm._v("\n          © Staromeštianska pivotéka - STAROMEŠŤAN s.r.o.  2017\n        ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50780142","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 111
// module chunks = 1